import { atom, map } from 'nanostores';

export interface SubAgentStep {
  timestamp: number;
  toolName?: string;
  message: string;
  status: 'running' | 'done' | 'error';
}

export interface SubAgentLog {
  agentId: string;
  label: string;
  toolCallId: string;
  steps: SubAgentStep[];
  status: 'running' | 'complete' | 'error';
  /** Live-streamed narration from the sub-agent (accumulated text deltas). */
  streamedText: string;
  summary?: string;
}

/**
 * Map of toolCallId → SubAgentLog.
 * Each sub-agent invocation gets its own log stream.
 */
export const $subAgentLogs = map<Record<string, SubAgentLog>>({});

/** Which sub-agent log is currently being viewed in the workbench panel */
export const $activeSubAgentId = atom<string | null>(null);

export function appendSubAgentStep(toolCallId: string, step: SubAgentStep) {
  const current = $subAgentLogs.get();
  const log = current[toolCallId];

  if (log) {
    $subAgentLogs.setKey(toolCallId, {
      ...log,
      steps: [...log.steps, step],
    });
  }
}

export function initSubAgentLog(toolCallId: string, agentId: string, label: string) {
  $subAgentLogs.setKey(toolCallId, {
    agentId,
    label,
    toolCallId,
    steps: [],
    streamedText: '',
    status: 'running',
  });
}

export function appendSubAgentText(toolCallId: string, delta: string) {
  const current = $subAgentLogs.get();
  const log = current[toolCallId];

  if (log) {
    $subAgentLogs.setKey(toolCallId, {
      ...log,
      streamedText: log.streamedText + delta,
    });
  }
}

export function completeSubAgentLog(toolCallId: string, summary?: string, error?: boolean) {
  const current = $subAgentLogs.get();
  const log = current[toolCallId];

  if (log) {
    $subAgentLogs.setKey(toolCallId, {
      ...log,
      status: error ? 'error' : 'complete',
      summary,
    });
  }
}

export function openSubAgentPanel(toolCallId: string) {
  $activeSubAgentId.set(toolCallId);
}
